// Per-site, per-environment values introduced by the domain split
// (design/DOMAIN_SPLIT.md). Endpoints that already exist as PUBLIC_* env vars
// (API, websocket, storage) stay env vars; this module owns only the values
// the split introduced, derived from PUBLIC_ENVIRONMENT + PUBLIC_SITE.
import { PUBLIC_ENVIRONMENT } from '$env/static/public';
import { IS_AQUEDUCT } from '$lib/site';

const prod = PUBLIC_ENVIRONMENT === 'prod';

export const AQUEDUCT_PRODUCTION_ORIGIN = 'https://aqueduct.sh';

const AQUEDUCT_ORIGIN = prod ? AQUEDUCT_PRODUCTION_ORIGIN : 'http://localhost:3001';

const ILIAD_ORIGIN = prod ? 'https://iliad.ai' : 'http://localhost:3000';

/** This site's own public origin (sitemap, canonical URLs). */
export const SITE_ORIGIN: string = IS_AQUEDUCT ? AQUEDUCT_ORIGIN : ILIAD_ORIGIN;

/** This site's public hostname (legal copy, user-facing text). */
export const SITE_DOMAIN: string = new URL(SITE_ORIGIN).hostname;

/** The Aqueduct site's origin, for cross-site links from iliad.ai. */
export const AQUEDUCT_SITE_ORIGIN: string = AQUEDUCT_ORIGIN;

/** The Iliad site's origin, for cross-site links from the Aqueduct site. */
export const ILIAD_SITE_ORIGIN: string = ILIAD_ORIGIN;

/** The Aqueduct MCP server URL, for docs and setup instructions. */
export const MCP_URL: string = prod ? 'https://mcp.aqueduct.sh' : 'http://localhost:8003';

/** The Aqueduct MCP server name used in setup commands. */
export const MCP_SERVER_NAME: string = prod ? 'aqueduct' : 'aqueduct-dev';

/** The Firebase auth domain for production builds of this site. */
export const PROD_AUTH_DOMAIN: string = IS_AQUEDUCT ? 'auth.aqueduct.sh' : 'auth.iliad.ai';

/** The Firebase auth domain for local and development builds of this site. */
export const DEV_AUTH_DOMAIN: string = IS_AQUEDUCT
	? 'auth-dev.aqueduct.sh'
	: 'auth-dev.iliad.ai';

/** The Firebase auth domain for this site and environment. */
export const FIREBASE_AUTH_DOMAIN: string = prod ? PROD_AUTH_DOMAIN : DEV_AUTH_DOMAIN;

/** Per-site Discord invite. */
export const DISCORD_URL: string = IS_AQUEDUCT
	? 'https://discord.gg/hYxHhBhFWZ'
	: 'https://discord.gg/hbb2qD57hM';
